import { ChangedPriceResponse } from "@/models/entities/changePrice/changedPrice.interface";
import { storageCertificate } from "@/models/entities/storage/storageInput/storageCertificate.interface";
import { ApiService } from "../api.service";

const CONTROLLER = "/ChangedPrice";

class ChangedPricesService extends ApiService {
  changedPricesService(choice: number, email: string) {
    return this.getAll<void>(`${CONTROLLER}/SendMailChangedPrice`, {
      params: {
        choice: choice,
        email: email,
      },
    });
  }
  downloadChangedPricesService(
    mak: boolean,
    avus: boolean,
    fondmetal: boolean,
    ruotiniImported: boolean,
    ruotiniMaster: boolean,
    ironWheelMaster: boolean,
    ruoteInLegaMaster: boolean,
    snowChain: boolean
  ) {
    return this.getAll<storageCertificate>(
      `${CONTROLLER}/DownloadChangedPrice`,
      {
        params: {
          Mak: mak,
          Avus: avus,
          FondMetal: fondmetal,
          RuotiniImported: ruotiniImported,
          ruotiniMaster: ruotiniMaster,
          ironWheelMaster: ironWheelMaster,
          ruoteInLegaMaster: ruoteInLegaMaster,
          snowChain: snowChain,
        },
      }
    );
  }
  getChangedPricesService(
    idCatalogo: number
    // avus: boolean,
    // fondmetal: boolean,
    // ruotiniImported: boolean,
    // ruotiniMaster: boolean,
    // ironWheelMaster: boolean,
    // ruoteInLegaMaster: boolean,
    // snowChain:boolean
  ) {
    return this.getAll<ChangedPriceResponse>(`${CONTROLLER}/GetChangedPrice`, {
      params: {
        IdCatalogo: idCatalogo,
        // Mak: mak,
        // Avus: avus,
        // FondMetal: fondmetal,
        // RuotiniImported: ruotiniImported,
        // ruotiniMaster: ruotiniMaster,
        // ironWheelMaster: ironWheelMaster,
        // ruoteInLegaMaster: ruoteInLegaMaster,
        // snowChain: snowChain
      },
    });
  }
}

export const changedPricesService = new ChangedPricesService();
